/**
 * Re-export useTranslations from next-intl for consistency
 * This allows us to import from our own hooks directory
 * and provides a single place to customize translation behavior if needed
 */
export { useTranslations } from 'next-intl';
export { useLocale } from 'next-intl';
export { useFormatter } from 'next-intl';
